import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findRefundFormDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/exit/detail/${id}`,
        method: 'GET',
    })
}
export const refuseToReturn = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/exit/dissident/${id}?` + params,
        method: 'GET'
    })
}
export const agreeToReturn = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/exit/refund/${id}`,
        method: 'GET'
    })
}